import React from "react";
import Select from "../../common/input/select";
import { connect } from "react-redux";
import SectionLoading from '../../common/SectionLoading';
import SectionLoadingError from '../../common/SectionLoadingError';

class ChoosePickupTime extends React.Component {
    constructor(props) {
        super(props);
        this.pickupTime = props.pickupTime;
        const pickupDay = props.pickupDay;
        this.state = {
            showAsInvalid: false,
            timeLabels: pickupDay ? this.getTimeLabels(pickupDay) : {},
            //selectedPickupDay: pickupDay ? pickupDay : 0,
            //selectedPickupTime: this.pickupTime
        };
    }    

    getTimeLabels(day) {
        const { pickupHours, pickupDates } = this.props;
        return pickupHours.filter(function (pickupHour) {
            return pickupHour.LongDisplayDate === pickupDates[day].label;
        });
    }

    onPickupDayChange = (e) => {
        const { onPickupDayChange } = this.props;
        const selectedDay = e.target.value;

        if (selectedDay) {
            this.pickupTime = null;            
            const timeLabels = this.getTimeLabels(selectedDay);
            this.setState({
                //selectedPickupDay: selectedDay,
                //selectedPickupTime: '',
                timeLabels
            });

            if (onPickupDayChange) {
                onPickupDayChange(selectedDay, timeLabels[0].DisplayDate1);
            }
        }
    }

    onPickupTimeChange = (index) => {
        const { pickupHours, onPickupTimeChange } = this.props;
        const { timeLabels, showAsInvalid } = this.state;
        let pickupDateTime = timeLabels && timeLabels[0] && timeLabels[0].AvailableDateTimes[index];
        let pickupTime = timeLabels && timeLabels[0] && timeLabels[0].AvailableTimes[index];

        if (!pickupDateTime) {
            pickupDateTime = pickupHours && pickupHours[0] && pickupHours[0].AvailableDateTimes[index];
            pickupTime = pickupHours && pickupHours[0] && pickupHours[0].AvailableTimes[index];
        }

        if (showAsInvalid) {
            this.setState({ showAsInvalid: false });
        }

        this.pickupTime = pickupTime;
        
        //this.setState({ selectedPickupDateTime: pickupDateTime, selectedPickupTime: pickupTime });

        if (onPickupTimeChange) {
            onPickupTimeChange(pickupTime);
        }
    }

    isValid() {
        const isValid = this.props.pickupTime !== null && this.props.pickupTime !== "";
        return isValid;
    }

    onGoNext(success) {
        if (success) {
            if (this.props.onSubmit) {
                this.props.onSubmit();
            }
        }
        else {
            this.setState({ showAsInvalid: true });
        }
    }

    render() {
        const serviceWaitings = (this.props.isPickupHoursWaiting === false || this.props.isPickupHoursWaiting === undefined) ? false : true;
        const serviceError = (this.props.isPickupHoursError === false || this.props.isPickupHoursError === undefined) ? false : true;
        const { timeLabels } = this.state;
        const { pickupDay, pickupTime } = this.props;

        var labels = timeLabels && timeLabels[0] ? timeLabels[0] : this.props.pickupHours ? this.props.pickupHours[0] : {};
        var timesUIelements = labels && labels.AvailableTimes && labels.AvailableTimes.map((item, index) => {
            return (
                <button key={index} type="button" className={"btn btn-primary " + (pickupTime === item ? 'active' : '')} onClick={() => this.onPickupTimeChange(index)}>{item}</button>
            );
        });

        return (
            <div style={this.props.style}>{serviceWaitings === true
                ? <SectionLoading />
                : <React.Fragment>{serviceError === false && this.props.pickupHours && this.props.pickupHours.length > 0
                    ? <div className="row select-pickup-time-container">
                        <div className="col-12">
                            <h2 className="step-heading desktop-element">When would you like to pick up the prescriptions?</h2>
                        </div>
                        <div className="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3 form-group select-pickup__day">
                            <Select id="selectoption" name="selectName" placeholder="Select a pick up day" value={pickupDay ? pickupDay : 0} prependIcon="icon-calendar-form"
                                options={this.props.pickupDates} onChange={e => this.onPickupDayChange(e)} required disableEmptyOption ref="date"
                            />
                        </div>
                        <div className="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 form-group select-pickup__time">
                            <div className="pickup-time-slots">
                                {timesUIelements}
                            </div>
                        </div>
                        {this.state.showAsInvalid &&
                            <div className="col-12 text-center validation-error-container">
                                <div className="error-msg">Please select a pickup time.</div>
                            </div>
                        }
                    </div>
                    : <div>{serviceError === true
                        ? <SectionLoadingError message="We’re unable to display the information. Please try again later." />
                        : <SectionLoadingError message="No times to display.  Please try again." sectionErrorClass="no-results-error" />
                    }</div>
                }</React.Fragment>
            }</div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        pickupHours: state.pharmacy.pickupHours,
        pickupDates: state.pharmacy.pickupDates,
        isPickupHoursWaiting: state.pharmacy.isPickupHoursWaiting,
        isPickupHoursError: state.pharmacy.isPickupHoursError
    };
};

export default connect(mapStateToProps, null, null, { withRef: true })(ChoosePickupTime);